// Close selects when clicking outside
document.addEventListener('click', (event) => {
    if (!event.target.closest('.rbt-select')) {
        document.querySelectorAll('.rbt-select').forEach(select => {
            select.classList.remove('active');
        });
    }
    if (!event.target.closest('.dismissable')) {
        document.querySelectorAll('.dismissable').forEach(options => {
            options.classList.remove('active');
        });
    }
});

document.addEventListener('DOMContentLoaded', function () {
    // Get the form element
    const form = document.getElementById('4772129');
    if (form) {
        // Get the Program dropdown
        const programDropdown = document.getElementById('tfa_22');

        // Define a mapping of URL paths to program values
        const urlToProgram = {
            '/tefl-certification': 'tfa_31', // TEFL
            '/adult/teach': 'tfa_28', // Teach Abroad
            '/adult/work': 'tfa_34', // Work Abroad
            '/adult/summer-programs': 'tfa_35', // Summer
            '/gap-year': 'tfa_25', // Gap Year
            '/groups/': 'tfa_26', // Group Trip
            '/high-school-abroad': 'tfa_27', // High School Abroad
            '/teach-homestay': 'tfa_29', // Teach English in a Homestay
            '/teen/language-camps': 'tfa_30', // Teen Summer Language Camp
            '/volunteer-abroad': 'tfa_33', // Volunteer Abroad
            '/teen-summer': 'tfa_36', // Teen Summer
            '/job-board': 'tfa_24', // Digital Nomad
        };
        // Add event listener to the form submission
        form.addEventListener('submit', function (event) {
            // Prevent the default form submission
            event.preventDefault();
            // Get the current URL path
            const currentPath = window.location.pathname;

            // Check if we have a mapping for this URL
            let programValue = null;
            // Loop through our mappings to find the first match
            for (const key of Object.keys(urlToProgram)) {
                if (currentPath.indexOf(key) !== -1) {
                    programValue = urlToProgram[key];
                    break; // Stop after finding the first match
                }
            }
            if (programValue) {
                // Set the value of the Program dropdown
                programDropdown.value = programValue;
            }
            // Now submit the form
            form.submit();
        });
    }
});
